const materialDivs = document.querySelectorAll('.material-section > div');
const optionImages = document.querySelectorAll('img[data-option-value-name]');

document.addEventListener('DOMContentLoaded', () => {
  if (window.matchMedia('(max-width: 750px)').matches) {
    handleMaterialGrid();
  }
  
  window.matchMedia('(max-width: 750px)').addEventListener('change', (e) => {
    if (e.matches) {
      handleMaterialGrid();
    } else {
      document.querySelectorAll('.material-show-more').forEach((button) => {
        button.remove();
      });
      document.querySelectorAll('.material-option-image').forEach((img) => {
        img.classList.remove('d-none');
      });
    }
  });
});

if (materialDivs.length > 0) {
  const firstMaterial = materialDivs[0];
  const firstMaterialName = firstMaterial.querySelector('h3').textContent.trim();
  const optionGroups = firstMaterial.querySelectorAll('.material-switch-flex');
  let i = 1;
  optionGroups.forEach((group) => {
    const optionLabel = group.querySelector('p');
    if (optionLabel) {
      const optionName = optionLabel.textContent.split(':')[0].trim();
      const span = group.querySelector('.seleceted-option-value');
      const firstImg = group.querySelector('img');

      if (i == 1) {
        if (span) span.textContent = ' ' + firstMaterialName;
        if (firstImg) firstImg.classList.add('selected');
      }
      i++;
    }
  });
}

function handleMaterialGrid() {
  const allMaterials = document.querySelectorAll('.material-options-flex');
  const selected = document.querySelector('.material-option-image.selected');
  const container = selected?.parentElement;
  const materials = container?.querySelectorAll('.material-option-image');
  if (!materials) {
    console.warn('No variable materials found');
    return;
  }

  let limitMaterialsOnMobile = 5;

  if (materials.length == 6) {
    limitMaterialsOnMobile = 6;
  }

  allMaterials.forEach((material) => {
    const currentMaterial = Array.from(material.children);
    currentMaterial.forEach((img, index) => {
      if (index >= limitMaterialsOnMobile) {
        img.classList.add('d-none');

        if (index == currentMaterial.length - 1) {
          const showMoreButton = document.createElement('button');
          showMoreButton.classList.add('material-show-more');
          showMoreButton.textContent = `+ ${materials.length - limitMaterialsOnMobile}`;
          showMoreButton.addEventListener('click', (e) => {
            e.preventDefault();
            document.querySelectorAll('.material-option-image').forEach((img) => {
              img.classList.remove('d-none');
            });
            document.querySelectorAll('.material-show-more').forEach((button) => {
              button.remove();
            });
            showMoreButton.remove();
          });
          material.appendChild(showMoreButton);
        }
      }
    });
  });
}

function clearAllImageSelections() {
  const allImages = document.querySelectorAll('.material-switch-part img');
  allImages.forEach((img) => img.classList.remove('selected'));
}

function hideAllMaterialDivs() {
  materialDivs.forEach((div) => {
    div.classList.add('tw-hidden');
    div.classList.remove('tw-grid');
  });
}

function showMaterialDiv(div) {
  div.classList.remove('tw-hidden');
  div.classList.add('tw-grid');
}

function updateGroupSelection(group, optionName, optionValue) {
  const groupName = group.querySelector('p').textContent.split(':')[0].trim();
  if (groupName === optionName) {
    const span = group.querySelector('.seleceted-option-value');
    if (span) {
      span.textContent = ' ' + optionValue;
    }

    const newGroupImages = group.querySelectorAll('img');
    newGroupImages.forEach((newImg) => {
      newImg.classList.remove('selected');
      if (newImg.getAttribute('data-option-value-name') === optionValue) {
        newImg.classList.add('selected');
      }
    });
  }
}

function findAndShowMatchingMaterial(optionValue, optionName) {
  let matchFound = false;

  materialDivs.forEach((div) => {
    const titleElement = div.querySelector('h3');
    if (titleElement && titleElement.textContent.trim() === optionValue) {
      showMaterialDiv(div);
      matchFound = true;

      const allGroups = div.querySelectorAll('.material-switch-flex');
      allGroups.forEach((group) => {
        updateGroupSelection(group, optionName, optionValue);
      });
    }
  });

  return matchFound;
}

function showDefaultMaterial(optionValue) {
  console.log('No material found with name: ' + optionValue);
  if (materialDivs[0]) {
    showMaterialDiv(materialDivs[0]);
  }
}

function handleOptionImageClick() {
  const optionValue = this.getAttribute('data-option-value-name');
  const clickedGroup = this.closest('.material-switch-flex');
  if (!clickedGroup) return;

  const optionName = clickedGroup.querySelector('p').textContent.split(':')[0].trim();

  clearAllImageSelections();
  this.classList.add('selected');
  hideAllMaterialDivs();

  const matchFound = findAndShowMatchingMaterial(optionValue, optionName);

  if (!matchFound) {
    showDefaultMaterial(optionValue);
  }
}

if (optionImages.length > 0) {
  showMaterialDiv(materialDivs[0]);
  optionImages.forEach((img) => {
    img.addEventListener('click', handleOptionImageClick);
  });
}
